// src/components/PolicyLayout.jsx
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../common/styles/policyPages.css";

const PolicyLayout = ({ title, subtitle, children }) => {
  return (
    <div className="policy-page">
      <Container>
        <Row className="justify-content-center">
          <Col lg={10}>
            <div className="page-breadcrumb">Home / {title}</div>
            <h1 className="page-title">{title}</h1>
            {subtitle && <p className="page-subtitle">{subtitle}</p>}
          </Col>
        </Row>

        <Row className="justify-content-center">
          <Col lg={10}>{children}</Col>
        </Row>
      </Container>
    </div>
  );
};

export default PolicyLayout;
